export const FLAT = "flat";
export const POSTER = "poster";
